import type { AnalyticsState, MutationClass } from '../../../models'

export class SetSelectedIdMutation implements MutationClass {
  static execute(this: void, state: AnalyticsState, selectedId: string): void {
    state.selectedId = selectedId
  }
}
